import { render, staticRenderFns } from "./loginnew.vue?vue&type=template&id=fab2184c&scoped=true"
import script from "./loginnew.vue?vue&type=script&lang=js"
export * from "./loginnew.vue?vue&type=script&lang=js"
import style0 from "./loginnew.vue?vue&type=style&index=0&id=fab2184c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab2184c",
  null
  
)

export default component.exports